import { render, staticRenderFns } from "./RewardItem.vue?vue&type=template&id=40f1a984&scoped=true&"
import script from "./RewardItem.vue?vue&type=script&lang=js&"
export * from "./RewardItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardItem.vue?vue&type=style&index=0&id=40f1a984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1a984",
  null
  
)

export default component.exports